import React, { ReactNode } from 'react'
import { Text, Box, Flex, Image, Button, ButtonProps } from 'theme-ui'
import { FaChevronDown, FaUserCircle, FaSignInAlt } from 'react-icons/fa'
import { useNavigate } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useQuery, useQueryClient } from 'react-query'

import SidebarMenu from './SidebarMenu'
import Dropdown, {
  DropdownButton,
  DropdownList,
  DropdownMenu,
} from '../Dropdown/Dropdown'
import useCurrentUserStore, {
  removeUserToken,
  getUserToken,
} from '../../stores/currentUser'
import api from '../../api/api'
import { notifySuccess } from '../Notif'

const logo =
  'https://www.pinclipart.com/picdir/big/18-185559_winter-cardinal-bird-clipart-clip-art-library-classroom.png'

export function HeaderComponent() {
  const userToken = getUserToken()
  const isEmptyCurrentUser = isEmpty(userToken)
  const navigate = useNavigate()
  const { removeCurrentUser } = useCurrentUserStore()
  const client = useQueryClient()

  function logout() {
    removeUserToken()
    removeCurrentUser()
    client.invalidateQueries('/reports')
    navigate('/login')
    notifySuccess('Logout successfull')
  }

  const { data } = useQuery<any>('getProfile', () => api.get('/profile'), {
    enabled: !isEmptyCurrentUser,
  })
  const profileData = data?.data?.data

  return (
    <Box
      sx={{
        width: '100%',
        height: '70px',
        bg: 'primary',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'fixed',
        zIndex: 5,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          padding: '1',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/')}
      >
        <Image src={logo} alt="aws" sx={{ height: '100%', pl: '1' }} />

        <Text
          sx={{
            color: 'white',
            fontSize: 4,
            px: '2',
          }}
        >
          WBS
        </Text>
        <Text
          sx={{
            color: 'white',
            width: '55px',
            fontSize: 0,
          }}
        >
          Whistle Blowing System
        </Text>
      </Box>
      <Box
        sx={{
          display: ['none', 'inline-flex', 'inline-flex'],
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-end',
          flexGrow: 1,
          height: '100%',
          px: '3',
        }}
      >
        {isEmptyCurrentUser ? (
          <HeaderMenu
            title="Login"
            icon={<FaSignInAlt />}
            onClick={() => navigate('/login')}
          />
        ) : (
          <Dropdown placement="bottom-end">
            <DropdownButton
              sx={{
                bg: 'unset',
                height: '100%',
                ':hover': { bg: 'secondary' },
              }}
            >
              <FaUserCircle color="white" />
              <Text ml={2} mr={2}>
                {profileData?.email}
              </Text>
              <FaChevronDown style={{ paddingTop: '5px' }} />
            </DropdownButton>
            <DropdownList>
              <DropdownMenu>Profil</DropdownMenu>
              <DropdownMenu>Ganti Password</DropdownMenu>
              <DropdownMenu onClick={logout}>Logout</DropdownMenu>
            </DropdownList>
          </Dropdown>
        )}
      </Box>
      <Box sx={{ display: ['inline-flex', 'none', 'none'] }}>
        <SidebarMenu />
      </Box>
    </Box>
  )
}

export const SimpleHeader = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        width: '100%',
        height: '70px',
        bg: 'primary',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          height: '100%',
          padding: '1',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => navigate('/')}
      >
        <Image src={logo} alt="aws" sx={{ height: '100%', pl: '1' }} />

        <Text
          sx={{
            color: 'white',
            fontSize: 4,
            px: '2',
          }}
        >
          WBS
        </Text>
        <Text
          sx={{
            color: 'white',
            width: '55px',
            fontSize: 0,
          }}
        >
          Whistle Blowing System
        </Text>
      </Box>
    </Box>
  )
}

interface HeaderMenuProps extends ButtonProps {
  title?: string
  icon?: ReactNode
}

function HeaderMenu({ title, icon, ...props }: HeaderMenuProps) {
  return (
    <Button
      bg="unset"
      color="gray1"
      sx={{
        height: '100%',
        ':hover': {
          bg: 'secondary',
        },
      }}
      {...props}
    >
      <Flex>
        <Box mr="5px" mt="2px">
          {icon}
        </Box>
        <Box>{title}</Box>
      </Flex>
    </Button>
  )
}
